// src/services/authService.js

import axiosInstance from '../axiosInstance'; 
import { store } from '../store'; 
import { setAuthToken } from '../features/authSlice';

export async function login(email, password) {
    try {
        const response = await axiosInstance.post('/api/login/', {
            email,
            password,
        });

        const data = response.data;

        // Dispatch the token to Redux and store in localStorage
        store.dispatch(setAuthToken(data.token));

        return data;
    } catch (error) {
        // Extract error message from the response if available
        const errorMessage = error.response?.data?.message || "Invalid email or password.";
        throw new Error(errorMessage);
    }
}
